import type { ReactElement } from 'react';

import { Box, Flex, Separator } from '@rango-dev/whale';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { profileSummarySelector } from '../../../state/ProfileSlice/selectors';

import { FavoriteItem } from './FavoriteItem';

const DESKTOP_COLUMN_COUNT = 2;

export function ProfileFavorites(): ReactElement {
  const params = useParams<{ username: string }>();
  const { data: profileSummary, loading } = useAppSelector((state) =>
    profileSummarySelector(state, params.username),
  );
  const { t } = useTranslation();

  const items = [
    {
      title: t('Favorite Token'),
      logo: profileSummary?.mostUsedToken?.logo,
      name: profileSummary?.mostUsedToken?.symbol,
    },
    {
      title: t('Favorite Chain'),
      logo: profileSummary?.mostUsedBlockchain?.logo,
      name: profileSummary?.mostUsedBlockchain?.shortName,
    },
    {
      title: t('Favorite DEX'),
      logo: profileSummary?.mostUsedDex?.logo,
      name: profileSummary?.mostUsedDex?.title,
    },
    {
      title: t('Favorite Bridge'),
      logo: profileSummary?.mostUsedBridge?.logo,
      name: profileSummary?.mostUsedBridge?.title,
    },
  ];

  const itemsPerColumn = Math.ceil(items.length / DESKTOP_COLUMN_COUNT);
  const columns = Array.from({ length: DESKTOP_COLUMN_COUNT }, (_, colIdx) =>
    items.slice(colIdx * itemsPerColumn, (colIdx + 1) * itemsPerColumn),
  );

  return (
    <Flex justify="between" direction={{ initial: 'column', md: 'row' }} gap={{ md: '5' }}>
      {columns.map((columnItems, colIdx) => (
        <Fragment key={columnItems[0]?.title ?? colIdx}>
          <Flex direction="column" width="100%">
            {columnItems.map((item, itemIdx) => (
              <Fragment key={item.title}>
                <FavoriteItem
                  title={item.title}
                  loading={loading}
                  logo={item.logo}
                  name={item.name}
                />
                {itemIdx < columnItems.length - 1 && <Separator size="4" />}
              </Fragment>
            ))}
          </Flex>
          {colIdx < columns.length - 1 && (
            <Box display={{ initial: 'block', md: 'none' }}>
              <Separator size="4" />
            </Box>
          )}
        </Fragment>
      ))}
    </Flex>
  );
}
